"use client";
import { Outlet } from "react-router-dom";

import { Footer } from "./Footer";
import { Header } from "./Header";

import { Provider } from "../i18n/useI18n";

const WrapperLayout = () => {
  return (
    <Provider>
      <Header />
      <Outlet />
      <Footer />
    </Provider>
  );
};
export default WrapperLayout;
